import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ContentfulService } from '../_services/contentful.service';

@Injectable({ providedIn: 'root' })
export class NewsRedirectGuard implements CanActivate {
  constructor(
    private contentfulService: ContentfulService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | import('@angular/router').UrlTree> {
    const id = route.params.id;
    const newsItem = await this.contentfulService.getNewsItemById(id);
    if (newsItem && newsItem.fields && newsItem.fields.slug) {
      return this.router.createUrlTree(['/news', newsItem.fields.slug, id]);
    } else {
      return this.router.createUrlTree(['/404']);
    }
  }
}